import Cookies from 'js-cookie';


class Cookie {
  getCookie = <T extends Record<string, unknown>>( name: string ): T => {
    let cookieStr = Cookies.get( name );

    if( !cookieStr ) {
      const newCookie = this.setCookieVal<T>( name, {} as T );
      cookieStr = JSON.stringify( newCookie );
    }

    const cookieObj = JSON.parse( cookieStr );

    return cookieObj;
  };

  setCookieVal = <T extends Record<string, unknown>>( name: string, val: T ): void => {
    try {
      Cookies.set( name, JSON.stringify( val ) );
    } catch( e ) {
      console.error( 'unable to parse cookie val' );
    }
  };

  setCookieKeyVal = <T extends Record<string, unknown>>( name: string, key: keyof T, val: unknown ): T => {
    const newCookie = {
      ...this.getCookie<T>( name ),
      [ key ]: val
    } as T;

    Cookies.set( name, JSON.stringify( newCookie ) );

    return newCookie;
  };
};

export const cookie = new Cookie();